import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { defaultAxiosInstance } from "services/client"

// This API is used to update location address for location details screen [step 1]
export interface UpdateLocationAddressResponse extends AxiosResponse {
  data: {
    data: string
    message: string
  }
}

export interface UpdateLocationAddressType {
  street: string
  area: string
  city: string
  stateCode: string
  zipcode: string
  postalName: string
  country: string
  latitude: number
  longitude: number
  id: string
}
export interface UpdateLocationAddressRequestData {
  street: string
  area: string
  city: string
  stateCode: string
  zipcode: string
  postalName: string
  country: string
  latitude: number
  longitude: number
}
export interface UpdateLocationAddressRequest
  extends Partial<AxiosRequestConfig> {
  data: UpdateLocationAddressRequestData
  params: {
    pmcId: string
    unitId: string
    listingReviewStep: string
  }
}

const defaultPublishPropertyURL = `${
  process.env.REACT_APP_BASE_API_URL || ""
}/rbo/update-address`

export function updateLocationAddressForProperty(
  {
    data,
    params,
    method = "post",
    url = defaultPublishPropertyURL,
    ...config
  }: UpdateLocationAddressRequest,
  axiosInstance: AxiosInstance = defaultAxiosInstance,
): Promise<UpdateLocationAddressResponse> {
  return axiosInstance({
    method,
    url: `${url}?pmcId=${params?.pmcId}&unitId=${params?.unitId}&listingReviewStep=${params?.listingReviewStep}`,
    data,
    ...config,
  }) as Promise<UpdateLocationAddressResponse>
}
